import { Box } from '@cad-arc';
import { EventPanelNarrative } from './event-panel-narrative';
import { useEventMetadataStore } from './event-panel-form/event-metadata';
import { EventPanelTabs } from './tabs/components/event-panel-tabs';
import { observer } from 'mobx-react-lite';

export const EventPanelRightPane = observer(function EventPanelRightPane(): React.ReactElement {
    const isSavedEvent = useEventMetadataStore().state.metadata?.eventClass !== undefined;

    return (
        <Box
            w="500px"
            h="100%"
            flexGrow={10000}
            backgroundColor="surface.canvas"
            borderLeft="sm"
            borderColor="border.default"
        >
            {isSavedEvent ? <EventPanelNarrative /> : <EventPanelTabs mode="FULL" />}
        </Box>
    );
});
